export const CustomersSceneTranslation = {
  fi: {
    ServiceCallCustomersScene: {
      title: 'Huoltokutsuliittymä - Asiakasyritykset',
      tabCustomers: 'Asiakkaat',
      tabInvites: 'Avoimet kutsut',
      businessName: 'Asiakasyritys',
      vehicleCount: 'Ajoneuvojen lukumäärä',
      startedAt: 'Aloituspäivämäärä',
      createdAt: 'Kutsu lähetetty',
      inviteEmail: 'Kutsuttavan asiakkaan sähköpostiosoite',
      inviteSubmit: 'Lähetä kutsu',
      inviteSuccess: 'Kutsu lähetettiin.',
      vehicles: 'Ajoneuvot',
      goToVehicles: 'Siirry ajoneuvoihin',
      endCustomer: 'Lopeta asiakkuus',
      endCustomerConfirmTitle: 'Päätetäänkö asiakkuus?',
      endCustomerConfirmDescription: 'Asiakkuus merkitään päättyneeksi. Tätä ei voi perua.',
      endCustomerConfirm: 'Lopeta',
      endCustomerCancel: 'Peruuta',
      endCustomerSuccess: 'Asiakkuus päätettiin.',
      cancelInvite: 'Peru',
      cancelInviteConfirmTitle: 'Perutaanko kutsu?',
      cancelInviteConfirmDescription: 'Avoin kutsu poistetaan.',
      cancelInviteConfirm: 'Peru kutsu',
      cancelInviteCancel: 'Peruuta',
      cancelInviteSuccess: 'Kutsu peruttiin.',
      emptyInvites: 'Ei avoimia kutsuja.',
      confirmCancel: 'Peruuta',
    },
  },
};
